let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dl6Ql")).then(() => parcelRequire('kiGd7'));